export const queryKeys = {
  cases: ["cases"] as const,
  case: (caseID: string) => [...queryKeys.cases, caseID] as const,
};

export default queryKeys;
